"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTSL001_Regist = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importDefault(require("styled-components"));
require("../../../assest/css/quill.scss");
const common_1 = require("../../../common");
const option_1 = require("../../../common/option");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const server_1 = require("../../../server");
const layout_1 = require("../../base/layout");
const action_1 = require("../../menu/action");
const constant_1 = require("./constant");
const RegistContent_1 = require("./DSTSL001_Regist_Child/RegistContent");
const DSTL001Styled = styled_components_1.default.div `
	background: var(--color-white, #ffffff);
	border-radius: 0px 0px 8px 8px;
	display: flex;
	flex-direction: column;
	gap: ${props => (props.$isMobile ? '12px' : '20px')};
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;
	width: 100%;
	flex: 1;
	padding: ${props => (props.$isMobile || props.$isTablet ? '20px' : '0px')};

	.field-global-001 {
		flex-direction: column;
		align-items: flex-start;

		.field-short {
			gap: 10px;
		}
	}

	.ql-editor {
		padding: 4px 12px;
	}

	.field-quill {
		display: inline-flex;
		flex-direction: row;
		gap: 10px;
		justify-content: flex-start;
		position: relative;
		width: 100%;
	}

	.learning-center-mw {
		width: 100%;
		height: 100%;
	}

	.content-regist-info {
		width: 100%;
	}

	.content-regist-width {
		display: flex;
		width: 100%;
		height: 100%;

		${props => props.$isMobile &&
    `
		
			.attach_file {
				button {
					padding: 10px;
					font-size: 12px;
				}
			} 

			.file {
				flex-direction: column-reverse;
			}
		`}

	.must-read {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 28px);
		font-weight: var(--b4-font-weight, 400);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.content-label {
		display: flex;
		gap: 4px;
		justify-content: flex-start;
		align-items: flex-end;
	}

	${props => props.$isMobile && mobileStyles}
	${props => props.$isTablet && tabletStyles}
`;
const tabletStyles = styled_components_1.default.div `
	${props => !props.$isPopup && `padding: 20px`};
	.content-regist-info {
		.task-label {
			font-size: 16px;
		}
	}
`;
const mobileStyles = `

	.btn-container {
		gap: 6px;
		margin-bottom: 10px;

		.button {
			height: 42px;
		}
	}
`;
exports.DSTSL001_Regist = react_1.default.memo(({ item, isModify = false, isTeacher, isResource, isPopup = false, }) => {
    const { classesId, isMobile, isDesktop, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [title, setTitle] = (0, react_1.useState)('');
    const [value, setValue] = (0, react_1.useState)('');
    const [fileList, setFileList] = (0, react_1.useState)();
    const [isImportance, setIsImportance] = (0, react_1.useState)(false);
    const fileMutation = (0, react_query_1.useMutation)(server_1.postFile);
    const updatePostsMutation = (0, react_query_1.useMutation)(server_1.postUpdatePosts);
    const registPostMutation = (0, react_query_1.useMutation)(server_1.registPosts);
    const handlerChecked = (id, checked) => {
        setIsImportance(checked);
    };
    (0, react_1.useEffect)(() => {
        if (item) {
            setTitle(item.title);
            setValue(item.content);
            setIsImportance(item.importance);
            setFileList(item.files || []);
        }
    }, [item]);
    (0, react_1.useEffect)(() => {
        if ((title && title.trim() !== '') ||
            (fileList && fileList.length > 0) ||
            (value && value.trim() !== '')) {
            APP.eventManager.publish('MENU_MOVE_ACTIVE', false);
        }
        else {
            APP.eventManager.publish('MENU_MOVE_ACTIVE', true);
        }
    }, [title, fileList, value]);
    //팝업창 바깥쪽 영역 클릭 시 팝업창 닫힘
    const popupRef = (0, react_1.useRef)(null);
    //게시글 등록, 수정
    const handlerSubmit = async () => {
        try {
            APP.eventManager.publish('SHOW_LOADING', true);
            APP.eventManager.publish('MENU_MOVE_ACTIVE', true);
            if (!title || title.trim() === '') {
                alert(t('supportRoom.titleAlert'));
                return;
            }
            if (value.replace(/<[^>]*>/g, '').trim().length === 0 || value.trim() === '') {
                alert(t('supportRoom.contentAlert'));
                return;
            }
            let convertAttachFileList = [];
            // 첨부 파일이 있는 경우
            if (fileList && fileList.length > 0) {
                const alredyFile = fileList.filter(file => typeof file === 'string');
                const filterFile = fileList.filter(file => file instanceof File);
                // 첨부 파일 업로드를 비동기로 실행하고 완료될 때까지 기다립니다.
                if (filterFile && filterFile.length > 0) {
                    const data = await fileMutation.mutateAsync(filterFile);
                    convertAttachFileList = [...data.result.link, ...alredyFile];
                }
                else {
                    convertAttachFileList = alredyFile;
                }
            }
            if (isModify) {
                const data = {
                    content: value,
                    files: convertAttachFileList,
                    importance: isImportance,
                    title: title.trim(),
                };
                await updatePostsMutation.mutateAsync({
                    id: item.id,
                    props: data,
                });
                handlerPreviousPage();
                handlerDetailPage();
            }
            else {
                const data = {
                    class_id: classesId,
                    content: value,
                    files: convertAttachFileList,
                    importance: isImportance,
                    title: title.trim(),
                    type: isResource ? 'study_data' : 'notice',
                };
                await registPostMutation.mutateAsync(data);
                handlerPreviousPage();
                APP.eventManager.publish(constant_1.REFRESH_POSTS_LIST);
            }
        }
        catch (error) {
            alert(error);
        }
        finally {
            APP.eventManager.publish('MENU_MOVE_ACTIVE', false);
            APP.eventManager.publish('SHOW_LOADING', false);
        }
    };
    const handlerPreviousPage = () => {
        dispatch((0, action_1.goToPrevMenu)());
    };
    const handlerDetailPage = () => {
        dispatch((0, action_1.updateMenu)(isResource ? 'learningSupportRoom' : 'notice', { menu: isResource ? 'resource' : 'notice', detail: 'detail' }, item.id, {
            item,
            isResource,
            selectedId: item.id,
        }));
    };
    /**
     * Q&A 답변 상단 타이틀
     */
    const renderTitleInfo = (0, react_1.useMemo)(() => (react_1.default.createElement(layout_1.DetailTitleInfo, { title: t(`menu.${isResource ? 'resource' : 'notice'}${isModify ? 'Modify' : 'Regist'}`), previousPage: handlerPreviousPage })), [isResource]);
    return (react_1.default.createElement(DSTL001Styled, { className: "dstl001_regist wrapper-padding", "$isMobile": isMobile, "$isTablet": isTablet, "$isPopup": isPopup, ref: popupRef },
        isDesktop && renderTitleInfo,
        react_1.default.createElement("div", { className: "field-global-001", style: { height: '100%', borderBottom: '1px dotted #B6BAC0', overflow: 'auto' } },
            react_1.default.createElement("div", { className: "content-regist-info", style: { borderBottom: '1px dotted #B6BAC0' } },
                react_1.default.createElement("div", { className: "field-short content-regist-width", style: {
                        alignItems: isMobile ? 'start' : 'center',
                        paddingBottom: '20px',
                        flexDirection: isMobile ? 'column' : 'row',
                    } }, isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.title')),
                    react_1.default.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '10px',
                            width: '100%',
                        } },
                        react_1.default.createElement("div", { className: "fext-field" },
                            react_1.default.createElement(common_1.InputElement, { type: "text", defaultValue: item && item.title, onChange: setTitle, placeholder: t('supportRoom.titlePlaceHolder') })),
                        react_1.default.createElement(common_1.CheckBoxElement, { id: "importance", title: "\uD544\uB3C5", checked: isImportance, handlerCheck: handlerChecked, className: "must-read" })))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "task-label" }, t('supportRoom.title')),
                    react_1.default.createElement("div", { className: "fext-field" },
                        react_1.default.createElement(common_1.InputElement, { type: "text", defaultValue: item && item.title, onChange: setTitle, placeholder: t('supportRoom.titlePlaceHolder') })))))),
            react_1.default.createElement("div", { className: "content-regist-info", style: {
                    paddingTop: '24px',
                    overflow: 'auto',
                    height: '100%',
                    minHeight: 265,
                } },
                react_1.default.createElement("div", { className: "content-regist-width" },
                    react_1.default.createElement(RegistContent_1.RegistContent, { contentName: t('supportRoom.content'), defaultValue: item?.content, setValue: setValue, 
                        // handlerTextLength={setTextLength}
                        isTeacher: isTeacher, containerRef: popupRef }))),
            react_1.default.createElement("div", { className: "content-regist-info", style: { padding: isMobile ? '24px 0px' : '20px 0px' } },
                react_1.default.createElement("div", { className: "content-regist-width" },
                    react_1.default.createElement(option_1.FileAttach, { id: "content_regist_file", isRegist: true, isNotice: true, fileList: fileList, setAttachFileList: setFileList })))),
        react_1.default.createElement("div", { className: "btn-container", style: { padding: '0px', width: isMobile ? '100%' : 'unset' } },
            !isMobile && (react_1.default.createElement(common_1.CheckBoxElement, { id: "importance", title: "\uD544\uB3C5", checked: isImportance, handlerCheck: handlerChecked, className: "must-read" })),
            react_1.default.createElement(common_1.Button, { className: `btn_white ${isMobile ? 'sm' : 'xmd'}`, text: "common.cancel", onClick: isPopup ? handlerDetailPage : handlerPreviousPage, styles: { buttonWrap: { width: isMobile ? '100%' : 'unset' } } }),
            react_1.default.createElement(common_1.Button, { className: `btn_default ${isMobile ? 'sm' : 'xmd'}`, text: "common.okay", onClick: handlerSubmit, styles: { buttonWrap: { width: isMobile ? '100%' : 'unset' } } }))));
});
